import { useClarificationRequestModel } from "entities/clarification-requests/model/useClarificationRequestModel"
import { clarificationRequestResourceTypeMap } from "entities/clarification-requests/types/ClarificationRequest"
import { useProjectPermissions } from "entities/projects/model/useProjectPermissions"
import { readonlyProjectPermissions } from "entities/projects/types/ProjectPermissions"
import { useAggregatedRoomData } from "entities/rooms/api/useAggregatedRoomData"
import { useRoomActionHandlers } from "features/room-management/model/useRoomActionHandlers"

import { RoomModel } from "../types/RoomModel"

export interface UseRoomOptions {
  includePrice?: boolean
}

export function useRoom({
  roomID,
  projectID,
  options
}: {
  roomID: string
  projectID: string
  options?: UseRoomOptions
}): RoomModel {
  const data = useAggregatedRoomData({ roomID, projectID, options })
  const { permissions } = useProjectPermissions({ projectID })
  const handlers = useRoomActionHandlers({
    projectID,
    roomID,
    permissions: permissions ?? readonlyProjectPermissions
  })
  const clarificationRequest = useClarificationRequestModel({
    resourceType: clarificationRequestResourceTypeMap.Room,
    id: roomID,
    projectID,
    options: { skip: !data.room?.data?.hasClarificationRequest }
  })

  const { onAssignAttachments, ...coreHandlers } = handlers

  return {
    core: {
      data: { room: data.room },
      handlers: coreHandlers
    },
    pricing: {
      data: { price: data.price }
    },
    clarificationRequest,
    attachments: {
      data: { attachments: null, linkedAttachments: null },
      handlers: { onAssignAttachments }
    }
  }
}
